let $hidebleSearch = $("#ssc_hidable_search");
let $prestepContainer = $("#ssc_prestep");
let $formContainer = $("#form-container");
let $categoriesContainer = $("#categories-container");
let $autocompleteSearchSku = $(".autocomplete-search-sku");
let $navigationBar = $("#ssc_navigation");
let $selectizeSkuInput = $( ".autocomplete-sku div input" );

let $selectizeSkuSearch = $autocompleteSearchSku.selectize({
  options:[],
  valueField: 'value',
  labelField: 'name',
  searchField: ['name'],
  maxItems: 1,
  render: {
    option: function(item, escape) {
      let label = item.name;
      return '<div>' +
        '<span class="label">' + escape(label) + '</span>' +
        '</div>';
    }
  }
});

if(window && window.smeg && window.smeg.ssc && !window.smeg.ssc.show_large_appliance_immediately && !window.smeg.ssc.show_small_appliance_immediately){
  $prestepContainer.show();
}

if(window && window.smeg && window.smeg.ssc && window.smeg.ssc.show_large_appliance_immediately){
  $categoriesContainer.show();
}

if(window && window.smeg && window.smeg.ssc && window.smeg.ssc.show_small_appliance_immediately){
  onSmallSelected();
  $formContainer.show();
  reloadForms();
}

$navigationBar.hide();

function onSKUSelected(){
  $hidebleSearch.hide();
  $categoriesContainer.hide();
  $formContainer.show();
  reloadForms();
  $("#submitButton").show();

  if($selectizeSkuInput[0].selectize){
    $selectizeSkuInput[0].selectize.clear(false);
    $selectizeSkuInput[0].selectize.destroy()
  }

  // set SKU selected in form
  let id = $autocompleteSearchSku.val();
  $('.autocomplete-sku input').val(id);
}

function onPrestepCategoriesSelected(){
  $categoriesContainer.hide();
  $formContainer.hide();
  $hidebleSearch.hide();
  $navigationBar.show();
  $(".ssc_boderded_box").removeClass("ssc_selected_button");
}

function onSearchSkuSelected(){
  $categoriesContainer.hide();
  $formContainer.hide();
  $hidebleSearch.show();
  $(".ssc_boderded_box").removeClass("ssc_selected_button");
  $navigationBar.hide();
}

function onLargeAppliancesSelected(){
  $categoriesContainer.show();
  $formContainer.hide();
  $(".ssc_boderded_box").removeClass("ssc_selected_button");
  $("#ssc_navigation_large_appliances").addClass("ssc_selected_button");
}

function handleAppliancesSelected (arrayIds) {
  $categoriesContainer.hide();
  window.scrollTo(0,0);
  $formContainer.show();
  reloadForms();

  if($("#ssc-form .eforms-page").length === 1){
    $("#ssc-form #submitButton").show();
  }

  // Set category id in input

  let skuInput = [];
  for(let id of arrayIds){
    let partial =  window.smeg.ssc.categories_sku[id].map(sku => {
      return {
        value: sku,
        name: sku
      };
    });
    skuInput.push(partial);
  }
  $selectizeSkuInput.selectize({
    options:[],
    valueField: 'value',
    labelField: 'name',
    searchField: ['name'],
    maxItems: 1,
    render: {
      option: function(item, escape) {
        let label = item.name;
        return '<div>' +
          '<span class="label">' + escape(label) + '</span>' +
          '</div>';
      }
    }
  });

  $selectizeSkuInput[0].selectize.clear(false);
  $selectizeSkuInput[0].selectize.clearOptions();
  $selectizeSkuInput[0].selectize.addOption(skuInput);
  $selectizeSkuInput[0].selectize.refreshOptions(false);
}

function onCategorySelected(id){
  $("#Category-id").val(id);
  handleAppliancesSelected([id]);
}

function onProfessionalSelected () {
  handleAppliancesSelected(window.smeg.ssc.categories_id_professional);
  $(".ssc_boderded_box").removeClass("ssc_selected_button");
  $("#ssc_navigation_professional_appliances").addClass("ssc_selected_button");
}

function onSmallSelected(){
  handleAppliancesSelected(window.smeg.ssc.categories_id_small);
  $(".ssc_boderded_box").removeClass("ssc_selected_button");
  $("#ssc_navigation_small_appliances").addClass("ssc_selected_button");
}

$(document).ready(function () {
  let skuInput = window.smeg.ssc.all_sku.map(sku => {
    return {
      value: sku,
      name: sku
    };
  });

  if($selectizeSkuSearch && $selectizeSkuSearch[0]){
    $selectizeSkuSearch[0].selectize.clear(false);
    $selectizeSkuSearch[0].selectize.clearOptions();
    $selectizeSkuSearch[0].selectize.addOption(skuInput);
    $selectizeSkuSearch[0].selectize.refreshOptions(false);
  }
});